import script from "./PaymentError.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PaymentError.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentError.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PaymentError.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__